/**
 * Created by yihong on 1/16/18.
 */

import { stringify } from 'query-string'
import axios from 'axios'
import loadjs from 'loadjs'
import { error_event, click_event } from '../tools/mgtv/analysis'
import { uuid } from '../tools/uuid'
import axiosRetry from 'axios-retry'; //目前只能适配到axios0.18.1  https://github.com/softonic/axios-retry/issues/59

const RISK_BIZ_DOMAIN = ['vipact3.api.mgtv.com']

const instant = axios.create({
  timeout: 10000,
  withCredentials: true,
});

const instant_retry = axios.create({
  timeout: 10000,
  withCredentials: true,
});

axiosRetry(instant_retry, {
  retryCondition: (error) => {
    return axiosRetry.isNetworkOrIdempotentRequestError(error)
      || error.code === 'ECONNABORTED';
  },
  retryDelay:(retryCount)=>{
    console.log('retry_times:',retryCount)
    return  retryCount * 1000;
  },
  shouldResetTimeout:true
},);

instant.interceptors.request.use(config => {
  const uid = uuid();
  if (!config.params) {
    config.params = {}
  }
  config.params._dx_const_id = window._dx_const_id
  config.params._dx_seq_id = uid;

  if(RISK_BIZ_DOMAIN.some(item => config.url.indexOf(item) >= 0)) {
    config.params.v = 'v4' // 此参数告诉后端风控使用的版本
  }

  return config;
})


instant.interceptors.response.use(response => {
  const resp = response.data;
  const config = response.config
  if (RISK_BIZ_DOMAIN.some(item => config.url.indexOf(item) >= 0)) {
    if (resp.ret === -99) {
      return show_captcha().then(token => {
        config.params._dx_token = token;
        return instant(config);
      })
    }
  }
  return response;
})






function null_to_undefined(obj) {
  if (obj) {
    const t = Object.assign({}, obj);
    Object.keys(t).forEach(k => {
      let val = t[k];
      if (val === null) {
        val = undefined;
      }
      t[k] = val;
    });
    return t;
  }
  return obj;
}



function checkResp(api_params) {
  try {
    const resp = api_params.resp;
    let url = api_params.url;
    if (!resp || !url) {
      return
    }
    url = url.replace(/^https?:/, "");
    url = url.split("?")[0]
    let error_msg = "";
    if (/vipact\d+.api.mgtv.com/.test(url)) {
      if (resp.ret < 0) {
        error_msg = url + ":" + resp.ret + ":" + resp.msg
      }
    } else if (/as.mgtv.com/.test(url)) {
      if (resp.status !== 200 && resp.status !== "200") { //有时是200 有的是"200"
        error_msg = url + ":" + resp.status + ":" + resp.msg

      }
    } else if (/nuc.api.mgtv.com/.test(url)) {
      if (resp.code !== 200 && resp.code !== "200") {
        error_msg = url + ":" + resp.code + ":" + resp.msg
      }
    } else if (/club.api.mgtv.com\/usercenter/.test(url)) { //主要是微信分享签名的接口
      if (resp.err !== 0 && resp.err !== "0") {
        error_msg = url + ":" + resp.code + ":" + resp.msg
      }
    }

    //作为apiRetError上报，error_msg 只做判断用
    if(error_msg && window.apmInst){
      window.apmInst.apiRetError(url, resp.msg)
    }
    // if (error_msg) {
    //   error_event(error_msg, { api: JSON.stringify(api_params) })
    // }
  } catch (e) {
    error_event(e, { api: JSON.stringify(api_params) }, "code_error")
  }
}

function checkApiError(e, api_params) {
  try {
    let url = api_params.url;
    if (!e || !url) {
      return
    }
    url = url.replace(/^https?:/, "");
    url = url.split("?")[0]
    console.error(e)
    if(window.apmInst){
      window.apmInst.apiError(url, e, api_params)
    }
    // if (e.message) {
    //   if (e.message.includes('timeout') || e.message.includes('timed out')) {

    //     // error_event(url, { api: JSON.stringify(api_params) }, "api_timeout")
    //     return
    //   }
    // } else if (e.message.includes('Request failed with status code')) {
    //   // error_event(url, { api: JSON.stringify(api_params) }, "api_status")
    //   return
    // }
    // error_event(e, { api: JSON.stringify(api_params) }, "code_error")
  } catch (e) {
    error_event(e, {}, "code_error")
  }
}




export function getJSON(url, params = {}, timeout = 10000, withCredentials = true, withRetry = false) {
  params = null_to_undefined(params);
  const api_params = {
    method: 'GET',
    url,
    params: JSON.stringify(params),
    timeout
  }
  let client = instant;
  if(withRetry){
    client = instant_retry;
  }

  return client.get(url, {
    params: params,
    timeout: timeout,
    withCredentials
  }).then(r => {
    const resp = r.data;
    api_params.resp = resp;
    checkResp(api_params);
    return resp
  }).catch(e => {
    checkApiError(e, api_params)
    return null
  })
}


export function postJSON(url, params, data, timeout = 10000) {
  params = null_to_undefined(params);
  const api_params = {
    method: 'POST',
    url,
    params: JSON.stringify(params),
    data: JSON.stringify(data),
    timeout
  }

  let target_url = url;
  if (params) {
    if (url.includes('?')) {
      target_url = target_url + "&" + stringify(params)
    } else {
      target_url = target_url + "?" + stringify(params)
    }
  }
  return instant.post(target_url, data).then(r => {
    const resp = r.data;
    api_params.resp = resp;
    checkResp(api_params);
    return resp
  }).catch(e => {
    checkApiError(e, api_params)
    return null
  })
}



import fetchJsonp from 'fetch-jsonp'



export function getJSONP(url, params = {}, timeout = 10000) {
  params = null_to_undefined(params);

  let target_url = url;
  const api_params = {
    method: 'getJSONP',
    url,
    params: JSON.stringify(params),
    timeout
  }
  if (params) {
    if (url.includes('?')) {
      target_url = target_url + "&" + stringify(params)
    } else {
      target_url = target_url + "?" + stringify(params)
    }
  }
  return fetchJsonp(target_url, {
    timeout: timeout
  }).then(r => {
    return r.json();
  }).then(resp => {
    api_params.resp = resp;
    checkResp(api_params)
    return resp;
  }).catch(e => {
    checkApiError(e, api_params)
    return null
  })
}


export function postForm(url, params, data, timeout = 10000) {
  params = null_to_undefined(params);
  params = Object.assign(params, {
    _source: window.gact.source,
    _uuid: window.$bus.user.uuid,
    _t: new Date().getTime()
  });
  let target_url = url;
  const api_params = {
    method: 'GET',
    url,
    params: JSON.stringify(params),
    data: JSON.stringify(data),
    timeout
  }
  if (params) {
    if (url.includes('?')) {
      target_url = target_url + "&" + stringify(params)
    } else {
      target_url = target_url + "?" + stringify(params)
    }
  }

  const formData = new FormData();
  for (let k in data) {
    formData.append(k, data[k]);
  }
  return instant.post(target_url, formData).then(resp => {
    return resp.data
  }).catch(e => {
    checkApiError(e, api_params)
    return null;
  })
}




let enable_upload = true;
export function upload_file(file, cb) {
  let ticket = window.$bus.user.ticket;
  if (!ticket) {
    return;
  }
  if (!enable_upload) {
    window.$toast('正在上传，请稍后')
    return;
  }
  const formData = new FormData();
  formData.append('file', file)
  const request = new XMLHttpRequest()

  const toast = window.$toast.loading({
    duration: 0,       // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    message: '上传中...',
    mask: true
  });

  request.open("POST", "//up.api.mgtv.com/api/v1/act/upload?ticket=" + ticket + "&act_name=" + window.rootdata.act_name)
  request.onload = function () {
    toast.clear();
    enable_upload = true;
    if (request.status === 200) {
      const res = JSON.parse(request.responseText);
      if (res.ret === 0) {
        console.log(res.data.url);
        window.$toast('上传成功')
        if (cb) {
          setTimeout(() => {
            cb(res.data.url);
          }, 0);
        }
      } else {
        window.$toast(res.msg || '上传失败,请重试')
      }
    } else {
      window.$toast('上传失败,请重试')
    }
  }

  request.onerror = function () {
    toast.clear();
    enable_upload = true;
    window.$toast('上传失败,请重试')
  }

  request.upload.onprogress = function (event) {
    if (event.lengthComputable) {
      var percent = Math.floor(event.loaded / event.total * 100);
      // 设置进度显示
      toast.message = `上传中...${percent}%`
      console.log(percent);
    }
  }

  enable_upload = false;
  setTimeout(() => {
    enable_upload = true;
  }, 5000);
  request.send(formData);
}


//显示验证码
function show_captcha() {
  return new Promise((resolve) => {
    if(window.$dx_instance && window.$dx_instance.showCaptcha) {
      click_event('展示验证码');
      window.$dx_instance.showCaptcha({
        cb: (success, data) => {
          if(success) {
            click_event('验证码验证成功');
            resolve(data)
          } else {
            click_event(`验证码验证失败(${data})`);
          }
        },
        options: {
          uid: window.$bus.user.uuid
        }
      })
    }
  })
}

//风控const id
function get_dx_const_id() {
  loadjs('https://vipcdn.mgtv.com/upload5/dx_sdk/1.0.0/rc.umd.min.js', {
    success: () => {
      // eslint-disable-next-line no-undef
      window.$dx_instance = new $dx_risk_control({
        ready: (success, data) => {
          if (success) {
            window._dx_const_id = data
          } else {
            click_event(`指纹id获取失败(${data})`)
          }
        },
        // cache: 0
      })
    },
    error: () => {
      error_event('风控sdk加载失败')
    },
    numRetries: 3
  })
}

setTimeout(get_dx_const_id, 0);
